<h1 mat-dialog-title>{{'User Details' | translate}}</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="fill">
      <mat-label>{{'Name' | translate}}</mat-label>
      <input type="text" matInput formControlName="name">
    </mat-form-field>
    <p>
      <mat-checkbox class="example-margin" formControlName="is_admin">{{'Admin' | translate}}</mat-checkbox>
    </p>
    <p>
      <mat-checkbox class="example-margin" formControlName="is_cook">{{'Cook' | translate}}</mat-checkbox>
    </p>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()">Save</button>
</div>
